"use client";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { createContext, useContext, useState } from "react";

const AppContext = createContext();

export function AppProvider({ children }) {
    const [userLogged, setUserLogged] = useState(null);

    return (
        <AppContext.Provider
            value={{
                userLogged,
                setUserLogged
            }}
        >
            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                {children}
            </GoogleOAuthProvider>
        </AppContext.Provider>
    );
}

export function useResource() {
    return useContext(AppContext);
}
